import * as React from 'react';
import { Typography, Grid2 as Grid } from '@mui/material';
import { SubscriptionOfferCard } from '../elements/subscription-offer-card';

interface SubscriptionFeatures {
  Cards: {
    id: number;
    title: string;
    subtitle: string;
    features: string[];
    titleColor: string;
    iconColor: string;
  }[];
  title: string;
  description: string;
}

interface SectionPricesSubscriptionsFeaturesProps {
  element: SubscriptionFeatures;
}

const courseData = [
  {
    title: 'I corsi',
    subtitle: "Sono sempre tutti inclusi nell'abbonamento.",
    features: [
      'Lezioni passo-passo con difficoltà crescente: da zero, principiante, intermedio, avanzato',
      'Il catalogo delle lezioni si espande ogni settimana',
      'Interazioni con gli insegnanti e materiale didattico per l’esercizio',
    ],
    titleColor: 'text-primary-main',
    iconColor: 'text-primary-main',
  },
  {
    title: 'Community',
    subtitle: 'Condividi la tua passione',
    features: [
      'Chiedi consigli e confrontati con altri musicisti e con il corpo insegnanti',
      'Lezioni di approfondimento in diretta e interviste esclusive',
      'Sfide mensili e tanto altro!',
    ],
    titleColor: 'text-secondary-main',
    iconColor: 'text-secondary-dark',
  },
];

export const SectionPricesSubscriptionsFeatures: React.FC<
  SectionPricesSubscriptionsFeaturesProps
> = ({ element }) => (
  <div className="px-4 md:px-8 lg:px-10 py-8">
    <div className="max-w-[1136px] mx-auto space-y-8">
      <div className="text-center">
        <Typography variant="h3" component="h3" className="mb-2">
          {element.title}
        </Typography>
        <Typography variant="body-500" component="p" className="text-text-secondary">
          {element.description}
        </Typography>
      </div>
      <Grid container spacing={2} alignItems="stretch">
        <Grid key={element.Cards?.[0].id} size={{ xs: 12, md: 6 }}>
          <SubscriptionOfferCard
            title={element.Cards[0].title}
            subtitle={element.Cards[0].subtitle}
            features={element.Cards[0].features}
            titleColor="text-primary-main"
            iconColor="text-primary-main"
          />
        </Grid>
        <Grid key={element.Cards?.[1].id} size={{ xs: 12, md: 6 }}>
          <SubscriptionOfferCard
            title={element.Cards[1].title}
            subtitle={element.Cards[1].subtitle}
            features={element.Cards[1].features}
            titleColor="text-secondary-main"
            iconColor="text-secondary-dark"
          />
        </Grid>
      </Grid>
    </div>
  </div>
);
